var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFavoritVerlauf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.665,
    height: 50.238,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clp1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M0 0h56.06v49.099H0z",
    shapeRendering: "crispEdges"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#clp1)",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-404.733 -254.733)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd1",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "translate(405.733 302.832) scale(54.0604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6465A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#7D65A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A566A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B466A1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#grd1)",
    d: "M459.719 272.296a8.574 8.574 0 00-.001-2.258c-.785-7.095-6.266-14.287-15.22-14.305l-.524.006c-4.109.121-7.526 1.607-11.081 4.817l-.294.241-.624-.744c-2.315-2.577-6.456-4.185-10.897-4.198-2.448.005-4.78.521-6.74 1.491l-.515.27c-4.503 2.496-7.505 7.099-8.033 12.309a12.542 12.542 0 00-.003 2.366c1.249 8.162 5.576 13.053 10.679 18.158 3.609 3.608 7.503 6.807 11.9 9.774l1.015.729c.73.535 1.833 1.346 2.7 1.696 0 0 .749.184.77.183.839-.02 2.516-1.245 3.626-2.056l.767-.55c4.564-3.133 8.458-6.331 11.904-9.777 4.798-4.795 9.219-9.794 10.571-18.152zm-2.669-1.276l-.018.706c-.362 6.789-4.944 11.91-9.607 16.572-4.427 4.428-8.462 7.446-14.359 11.467l-.202.139-.205-.135c-7.268-4.78-15.386-10.699-20.492-18.358-1.575-2.36-3.418-5.558-3.69-9.356l-.033-.912a12.863 12.863 0 012.231-7.224c1.677-2.427 5.069-5.145 9.565-5.495l1.042-.041h.058c4.458.018 7.517 2.269 9.357 4.218l.196.214.557.683c.484.627.724.904 1.305.904.755 0 1.612-1.061 2.302-1.913l1.098-1.209.603-.452c2.17-1.522 4.979-2.399 7.779-2.408 1.513.004 2.961.265 4.315.779l.269.107c3.661 1.501 7.936 5.47 7.929 11.714z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoritVerlauf);
export default __webpack_public_path__ + "static/media/Icon_Favorit_Verlauf.ce0fa632c064ff746a12391a53a9ab8e.svg";
export { ForwardRef as ReactComponent };